export default {
  "cashTransferRecord.thead.userno": "User ID",
  "cashTransferRecord.thead.transferId": "Transfer ID",
  "cashTransferRecord.thead.providerAgentDesc": "Vendor",
  "cashTransferRecord.thead.amount": "Amount",
  "cashTransferRecord.thead.beforeBalanceAmount": "Platform Balance Before Transfer",
  "cashTransferRecord.thead.beforeGameBalance": "Vendor Balance Before Transfer",
  "cashTransferRecord.thead.operationDetail": "Transfer Description",
  "cashTransferRecord.thead.statusDesc": "Transfer Status",
  "cashTransferRecord.thead.createTime": "Transfer Time",
  "cashTransferRecord.thead.action": "Action",
  "cashTransferRecord.action.updateStatus": "Change Status",
  "cashTransferRecord.action.updateStatus.confirmTitle": "Confirm status update?",
  "cashTransferRecord.action.updateStatus.confirmContent": "Transfer: {transferId}",
  "cashTransferRecord.action.updateStatus.confirmOk": "Confirm",
  "cashTransferRecord.action.updateStatus.confirmCancel": "Cancel",
  "cashTransferRecord.action.updateStatus.field.status": "Target Status",
  "cashTransferRecord.action.updateStatus.field.status.required": "Please select a target status",
  "cashTransferRecord.action.updateStatus.success": "Status updated successfully",
  "cashTransferRecord.action.updateStatus.failed": "Failed to update status",
  "cashTransferRecord.status.success": "Success",
  "cashTransferRecord.status.failed": "Failed",
  "cashTransferRecord.direction.in": "To Game Wallet",
  "cashTransferRecord.direction.out": "To Main Wallet",
  "cashTransferRecord.direction.unknown": "Unknown",
};
